export default "__VITE_ASSET__DpckYvze__"